import { Pipe, PipeTransform } from "@angular/core";
import { FormSubmissionStatus } from "../enums/form-submission-status";
import { getFormSubmissionStatusColor } from "../helpers/get-form-submission-status-color";

@Pipe({name: 'getFormSubmissionStatusColor'})
export class GetFormSubmissionStatusColorPipe implements PipeTransform {
  transform(value: FormSubmissionStatus): string {
    return getFormSubmissionStatusColor(value);
  }
}